(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-second-video-tile"] && !Shopify.designMode) return;
  try {
    (() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) {
        if (!target.getAttribute('src')) {
          target.src = target.dataset.videoSrc;
          target.load();
        }
        if (!reducedMotion.matches) target.play().catch(() => {});
      } else {
        target.pause();
      }
    });
  }, { threshold: 0.15 });
  const initialize = () => document.querySelectorAll('.d5-collection-video:not([data-observed])').forEach(video => {
    video.dataset.observed = 'true';
    observer.observe(video);
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-video-tile"] && !Shopify.designMode) return;
  try {
    (() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) {
        if (!target.getAttribute('src')) {
          target.src = target.dataset.videoSrc;
          target.load();
        }
        if (!reducedMotion.matches) target.play().catch(() => {});
      } else {
        target.pause();
      }
    });
  }, { threshold: 0.15 });
  const initialize = () => document.querySelectorAll('.d5-collection-video:not([data-observed])').forEach(video => {
    video.dataset.observed = 'true';
    observer.observe(video);
  });
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

})();
